import type { PortalProjectDirectoryResponse } from "@mbbe/types";
import { destekApiFetch } from "../../destek/lib/destekApiClient";

/** Bounded, grant-aware project id/name directory shared by the portal shell. */
export const getPortalProjects = () =>
  destekApiFetch<PortalProjectDirectoryResponse>("/portal/projects");
